import React from "react";
import "./index.css";
import { Link, useNavigate } from "react-router-dom";
import landingImage4 from "../../Assets/Home/landingImage4.png";
import clientsLogo from "../../Assets/Home/clientsLogo.png";
import vendorsLogo from "../../Assets/Home/vendorsLogo.png";
import consultantsLogo from "../../Assets/Home/consultantsLogo.png";
import whychooseprolegion from "../../Assets/Home/whychooseprolegion.png";
import videoimage from "../../Assets/Home/videoimage.png";
import collaboration from "../../Assets/Home/collaboration.png";
import timesheet from "../../Assets/Home/timesheet.png";
import invoice from "../../Assets/Home/invoice.png";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar";
import { useSelector } from "react-redux";

const Home = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.user.value);

  const headingData =
    "Simplify, Maximize, and Enhance: IT Workforce management made easy!";
  const contentData =
    "Boost the efficiency of your IT workforce with ProLegion- a simplified and unified platform that enables a seamless working experience for clients, vendors, and consultants. Create jobs, meet new clients, and find new opportunities all in one place!";

  return (
    <div>
      {/* <Header /> */}
      <Navbar />

      {/* Landing Component */}
      <div
        className="flex items-center -mt-12 md:-mt-24"
        style={{
          height: "100vh",
          backgroundSize: " 100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="flex flex-col-reverse lg:flex-row text-center justify-center mx-2 sm:mx-12 py-0"
        >
          <div className="flex flex-col space-y-10 text-justify">
            <div className="text-center lg:text-start">
              <span
                className="text-[40px] md:text-[51px]"
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  // fontSize: "51px",
                  lineHeight: "63px",
                }}
              >
                {headingData}
              </span>
            </div>
            <div
              className="text-center lg:text-left"
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "18px",
                lineHeight: "27px",
              }}
            >
              {contentData}
            </div>
            <div className="flex lg:justify-start justify-center">
              <button
                className=" h-[50px] w-[191px] hover:h-[53px] hover:w-[195px]"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  navigate(isLoggedIn ? "/dashboard" : "/signup");
                }}
              >
                <button
                  style={{
                    borderRadius: "25px",
                    color: "white",
                  }}
                  className="bg-[#139588] h-[50px] w-[191px] hover:h-[53px] hover:w-[195px] shadow-md shadow-gray-400 mt-[2px]"
                >
                  Try For Free
                </button>
              </button>
            </div>
          </div>
          <div className="flex justify-center mt-0 sm:mt-32">
            <img
              alt="landingImage"
              className="sm:ml-0 md:mt-48 lg:-mt-24 lg:ml-12 lg:w-[1200px] max-h-[500px]"
              src={landingImage4}
            />
          </div>
        </div>
      </div>

      {/* UserTypes */}
      <div className="flex lg:flex-row lg:space-y-0 space-y-8 flex-col justify-evenly items-center pb-32 ">
        <div className="w-[394px] flex lg:mt-0 md:mt-[150px] sm:mt-[200px] space-x-8 flex-row h-[320px] bg-[#E7FFFB]">
          <div className="pt-4 pl-6">
            <img
              alt="client"
              className="cursor-pointer rounded-sm"
              src={clientsLogo}
            />
          </div>
          <div className="flex flex-col pt-4 pr-6 space-y-4 relative">
            <div className="text-[#139588]">Clients</div>
            <div>
              Build your IT workforce pool  to meet your complex IT needs. Hire and retain specialized skills
              working with your IT partners. A unified platform where you can interact with vendors, create jobs,
              find talent, track timesheets, invoices and do much more.
            </div>
            <div>
              <Link to="/client">
                <div className="flex">
                  <button
                    style={{
                      position: "absolute",
                      background: "#139588",
                      bottom: "1rem",
                      borderRadius: "25px",
                      color: "white",
                    }}
                    className="shadow-md mt-12 h-[40px] w-[120px] hover:h-[42px] hover:w-[125px] shadow-gray-400"
                  >
                    See More
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="w-[394px] flex lg:mt-0 md:mt-[150px] sm:mt-[200px] space-x-8 flex-row h-[320px] bg-[#E7FFFB]">
          <div className="pt-4 pl-6">
            <img
              alt="client"
              className="cursor-pointer rounded-sm"
              src={vendorsLogo}
            />
          </div>
          <div className="flex flex-col pt-4 pr-6 space-y-4 relative">
            <div className="text-[#139588]">Vendors</div>
            <div>
              Manage clients and consultants on a single platform and find new opportunities for growth.Expand your business
              and find the right talent for your clients by leveraging the power of our extensive network.
            </div>
            <div>
              <Link to="/vendor">
                <div className="flex">
                  <button
                    style={{
                      position: "absolute",
                      bottom: "1rem",
                      background: "#139588",
                      borderRadius: "25px",
                      color: "white",
                    }}
                    className="shadow-md mt-6 h-[40px] w-[120px] hover:h-[42px] hover:w-[125px] shadow-gray-400"
                  >
                    See More
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="w-[394px] flex lg:mt-0 md:mt-[150px] sm:mt-[200px] space-x-8 flex-row h-[320px] bg-[#E7FFFB]">
          <div className="pt-4 pl-6">
            <img
              alt="client"
              className="cursor-pointer rounded-sm"
              src={consultantsLogo}
            />
          </div>
          <div className="flex flex-col pt-4 pr-6 space-y-4 relative">
            <div className="text-[#139588]">Consultants</div>
            <div>
              Harness the power of ProLegion’s extensive professional network to find new projects
              and keep your business contacts safe. A simplified platform where you can showcase
              your skills and grow professionally.
            </div>
            <div>
              <Link to="/consultant">
                <div className="flex">
                  <button
                    style={{
                      position: "absolute",
                      background: "#139588",
                      bottom: "1rem",
                      borderRadius: "25px",
                      color: "white",
                    }}
                    className="shadow-md mt-6 h-[40px] w-[120px] hover:h-[42px] hover:w-[125px] shadow-gray-400"
                  >
                    See More
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Why Prolegion */}

      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col"
      >
        <div
          style={{
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "24px",
            lineHeight: " 36px",
            paddingTop: "32px",
            paddingBottom: "8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Why Choose ProLegion?
        </div>
        <div className="flex lg:flex-row justify-center flex-col-reverse lg:justify-evenly pb-12 items-center">
          <div className="lg:w-[30%] space-y-4 px-8 sm:px-12 md:px-32 pt-8 lg:pt-0 lg:px-0 text-justify">
            <p className="font-[Roboto] font-medium text-[24px] leading-[36px] hidden lg:block text-left">
              Simplified Management and Communication
            </p>
            <div>
              ProLegion is a centralized platform providing end to end solutions for the job lifecycle.
              It simplifies the process of job posting, hiring, application management, record maintenance,
              communication tracking, and contract management. With our simplified vendor management solution,
              we empower organizations to effectively collaborate and communicate with their vendors and
              consultants. ProLegion helps businesses to optimize their IT consulting processes and ensure
              efficient utilization of resources..
            </div>
          </div>
          <div className="flex justify-center">
            <img
              alt="whyprolegion"
              className="sm:h-[550px] "
              src={whychooseprolegion}
            />
          </div>
        </div>
      </div>

      {/* Prolegion Video Section */}
      <div
        style={{
          background: "#EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col"
      >
        <div className="flex bg-white pt-12 lg:flex-row flex-col items-center lg:justify-evenly pb-12">
          <div className="flex justify-center">
            <img
              alt="simplifybusiness"
              className="sm:h-[450px] "
              src={videoimage}
            />
          </div>
          <div className="lg:w-[30%] space-y-4 px-8 sm:px-12 md:px-32 pt-16 lg:pt-0 lg:px-0 text-justify">
            <p className="font-[Roboto] font-medium text-[24px] leading-[36px] hidden lg:block text-left">
              Manage Your Business with ProLegion
            </p>
            <p>
              Level up with real-time data tracking, customizable dashboards, and automated workflow. A solution
              that helps you boost productivity, enhance performance, and increase the efficiency of your IT workforce.
              Experience a new level of efficiency with our solution, offering real-time tracking of activities,
              customizable dashboards, and automated workflows. Elevate productivity, enhance performance, and optimize
              the efficiency of your IT workforce with end to end solutions. Maximize your team's potential and
              achieve superior outcomes with our solution's comprehensive features.
            </p>
          </div>
        </div>
      </div>

      {/* How Prolegion Works */}

      <div
        style={{
          background: " #EDFDF9",
          display: "flex",
          justifyContent: "center",
        }}
        className="flex flex-col"
      >
        <div
          style={{
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "24px",
            lineHeight: " 36px",
            paddingTop: "32px",
            paddingBottom: "48px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          How Can ProLegion Help You?
        </div>

        <div className="flex lg:flex-row flex-col lg:justify-evenly">
          <div className="lg:w-[300px] md:w-[650px] sm:w-[450px] w-[300px] my-8">
            <div className="flex justify-center">
              <img src={collaboration} alt="collaboration" />
            </div>
            <div className=" mt-6 text-center">
              Experience unparalleled workforce management capabilities and take control like never before.
              Harness the power of seamless collaboration with your clients, vendors and consultants.
              Streamline cumbersome processes using automated notifications, customizable dashboards,
              and in-depth reports. Empower your team to work harmoniously towards a unified goal, no matter
              where they are in the world. With our comprehensive solution, unleash the full potential of
              your workforce and maximize productivity.
            </div>
          </div>
          <div className="lg:w-[300px] md:w-[650px] sm:w-[450px] w-[300px] my-8">
            <div className="flex justify-center">
              <img src={timesheet} alt="timesheet" />
            </div>
            <div className="mt-6 text-center">
              Focus on your business instead of overhead activities. Effortlessly streamline timesheet management
              by simplifying the processes.  Avoid delays for submissions, approvals with the aid of in-build workflow.
              No more follow ups or manual intervention for your busy consulting resources. Reduce the documents
              clutter for the month end activities.
            </div>
          </div>
          <div className="lg:w-[300px] md:w-[650px] sm:w-[450px] w-[300px] my-8">
            <div className="flex justify-center">
              <img src={invoice} alt="invoice" />
            </div>
            <div className="mt-6 text-center">
              Transform your organization's billing process by standardizing, streamlining, and automating it with ease.
              Experience the power of our effective and efficient invoice management system, enabling seamless generation
              and distribution of invoices. Overcome the challenges of manual invoicing and embrace the efficiency of
              our automated solution. Empower your organization with streamlined invoicing that enhances productivity.
            </div>
          </div>
        </div>
      </div>

      {/* Contact Us */}
      <div
        className="my-8 md:mx-24 sm:mx-12 mx-4"
        style={{
          boxSizing: "border-box",
          border: " 1px solid #787878",
          borderRadius: "9px",
        }}
      >
        <div
          style={{
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "24px",
            lineHeight: "36px",
            paddingTop: "12px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          Let&apos;s get in touch!
        </div>
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="flex lg:flex-row flex-col lg:mt-0 mt-8 justify-evenly"
        >
          <div>
            <div className="flex flex-row space-x-4 justify-center items-center">
              <span
                style={{ color: "#139588" }}
                className="text-5xl font-semibold"
              >
                @
              </span>
              <span
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "24px",
                  lineHeight: "36px",
                }}
              >
                Email :
              </span>
              {/* <span
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "24px",
                  lineHeight: "36px",
                }}
              >
                Email :
              </span> */}
            </div>
            contactus@ProLegion.com
          </div>
          <div>
            <div className="flex md:flex-row flex-col my-6 md:space-x-20">
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass text-[0.9rem] lg:text-[1.2rem] p-4 md:mb-0 mb-6 md:w-full w-72"
                placeholder="Your Name"
              />
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass text-[0.9rem] lg:text-[1.2rem] p-4 md:w-full w-72"
                placeholder="Your Email ID"
              />
            </div>
            <div className="my-6">
              <input
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass text-[0.9rem] lg:text-[1.2rem] p-4 md:w-full w-72"
                placeholder="Subject"
              />
            </div>
            <div className="mt-6 mb-24">
              <textarea
                style={{ border: "1px solid #787878", borderRadius: "4px" }}
                className="homeInputClass text-[0.9rem] lg:text-[1.2rem] p-4 md:w-full h-36 w-72"
                placeholder="Your Message"
              />

              <div className="">
                <button
                  style={{
                    position: "absolute",
                    background: "#139588",
                    borderRadius: "25px",
                    marginTop: "30px",
                    color: "white",
                  }}
                  className="h-[50px] w-[191px] hover:h-[53px] hover:w-[195px]"
                >
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
